import { IconProps } from '.';
const HeartIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 33 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClasses}
      {...rest}
    >
      <path
        id="icon-"
        d="M12.1765 3.04315L16.5 6.66667L20.7342 2.95673C23.2277 0.771921 27.0206 1.02349 29.2037 3.5185L29.6245 3.9994C32.077 6.80229 31.9054 11.0348 29.2339 13.6299L16.5 26L3.84706 13.7086C1.14291 11.0817 1.00489 6.78507 3.53487 3.99005L3.87417 3.61521C6.03822 1.22444 9.70498 0.971794 12.1765 3.04315Z"
        stroke={color || '#383E31'}
        strokeWidth="2"
      />
    </svg>
  );
};

export default HeartIcon;
